import { EmptyState, PageHeader } from '@portals-platform/ui';
import { SettingsIcon } from 'lucide-react';
import { PortalShell } from '../components/portal-shell.js';

export function SettingsPage() {
  return (
    <PortalShell activeId="settings" pageTitle="Settings">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <PageHeader
          title="Settings"
          description="Configure workspace preferences and integrations."
        />
        <EmptyState
          icon={<SettingsIcon />}
          title="Settings coming soon"
          description="Workspace configuration, notification preferences, and integration settings will appear here."
        />
      </div>
    </PortalShell>
  );
}
